import _ from 'lodash'
import Vue from 'vue'
import Axios from 'axios'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import VueLazyload from 'vue-lazyload'
import Settings from '@/config/Settings'

import App from '@/App.vue'
import store from '@/vuex/Store'
import { mappingRoutes } from '@/Route.js'
import TranslationMixin from '@/core/mixins/Translation'
import CommonsMixin from '@/mixins/Commons'
import LangMixin from '@/core/mixins/Lang'
import '@/core/js/Copyright'

import { TweenMax, CSSPlugin, PixiPlugin, TimelineMax, Expo, Linear, Back, BezierPlugin } from 'gsap/all'
// because of three shaking
const gsapPlugins = [ TweenMax, CSSPlugin, PixiPlugin, TimelineMax, Expo, Linear, Back, BezierPlugin ]

import * as PIXI from 'pixi.js'
// import Browserizr from 'browserizr'
import isMobile from 'ismobilejs'

PixiPlugin.registerPIXI(PIXI)

// import { _gsScope } from 'gsap/TweenLite'
// import { filters, DisplayObject } from 'pixi.js'

// _gsScope['PIXI'] = {
//   filters: filters,
//   DisplayObject: DisplayObject
// }

const axios = Axios.create({ baseURL: '/wp-json/acf/v3' })
Vue.prototype.$http = axios
Vue.use(VueRouter)
Vue.use(Meta,{
  keyName: 'head'
})
Vue.use(VueLazyload)
Vue.mixin(TranslationMixin)
Vue.mixin(CommonsMixin)

const init = async () => {

  if(process.env.NODE_ENV !== 'production' && Settings.cms) {
    const res = await axios.get('pages', { params: { hide_empty: 0, per_page: 500 }})
    window.__ENV = {}
    window.__ENV['ROUTES'] = _.map(res.data, d => ({
      id: d.id,
      name: d.acf.admin.route_key,
      component: d.acf.admin.component,
      fr: d.acf.admin.fr.slug,
      en: d.acf.admin.en.slug
    }))
  }

  if(!Settings.cms) {
    // hardcoded routes
    window.__ENV = {}
    window.__ENV['ROUTES'] = [
      { id: 'home', name: 'home', component: 'home/Home', fr: 'accueil', en: 'home' },
      { id: 'about', name: 'about', component: 'about/About', fr: 'a-propos', en: 'about' },
    ]
  }

  const router = new VueRouter({
    mode: 'hash',
    routes: mappingRoutes(window.__ENV['ROUTES'])
  })

  new Vue({
    el: '#App',
    store,
    router,
    mixins: [ LangMixin ],
    head() {
      return {
        htmlAttrs: { lang: this.lang }
      }
    },
    data: () => ({
      width: window.innerWidth,
      height: window.innerHeight,
			forceProd: false,
			orientation: 'portrait',
			speedMode: false,
			isModeVideo: false,
      isIE: false,
      isEDGE: false,
      speed: 1,
      compte: 0,
      usingMouse: true,
      usingTab: false,
      mode: {
				dev: process.env.NODE_ENV != 'production',
				prod: process.env.NODE_ENV == 'production'
      }
    }),
    beforeCreate() {
      this.$store.commit('app/LANG_CHANGED', this.$route.meta.lang)
      this.$store.commit('app/SET_FROM_ROUTE', this.$route)
      this.$store.commit('app/SET_TO_ROUTE', this.$route)
    },
    created() {

      if(this.forceProd) {
				this.mode.dev = false
				this.mode.prod = true
      }

      if(this.mode.prod)
        this.speedMode = false

      // console.log(isMobile(window.navigator).any);
      // const browser = Browserizr.detect()
      // if(browser.isMobile() || browser.isIPad() || isMobile(window.navigator).apple.tablet)

      if(isMobile(window.navigator).any || isMobile(window.navigator).apple.tablet)
        this.isModeVideo = true

      const ua = window.navigator.userAgent
      const msie = ua.indexOf('MSIE ')
      const trident = ua.indexOf('Trident/')
      const parser = new UAParser()
      const result = parser.getResult()
      const browser = result.browser.name
      const version = result.browser.version.split('.')[0]

      if(browser == 'Edge' && Number(version)<84)
        this.isEDGE = true
      
      if(msie != -1 || trident != -1) 
        this.isIE = true

      window.addEventListener('resize', () => { this.dispatchResize() })
      window.addEventListener('orientationchange', () => { 

        document.documentElement.style.height = 'initial'
        setTimeout(() => {
          document.documentElement.style.height = '100%'
            setTimeout(() => {
              window.scrollTo(0, 1)
            }, 200)
        }, 200)

        this.dispatchResize() 
      })

      this.$sizes =  {
        phone: 767,
        tabletPortrait: 768,
        tablet: 1024,
      }

      this.$scale = .5
      this.$scale_optimize = (this.$root.above('tablet')) ? .5 : 1

      // if(this.above('tabletPortrait')) {
      //   this.$optimize = 'large'
      //   this.$scale = .5
      // } else {
      //   this.$optimize = 'small'
      //   this.$scale = 1
      // }

    },

    mounted() {
      this.onResize()

      // Let the document know when the mouse is being used
      document.body.addEventListener('mousedown', () => {
        this.beUsingMouse()
      })

      // Re-enable focus styling when Tab is pressed
      document.body.addEventListener('keydown', event => {
        if (event.keyCode === 9) 
          this.beUsingTab()
      })

      // document.body.addEventListener('keyup', event => {
      //   if (event.keyCode != 9) 
      //     TweenMax.delayedCall(2, ()=> this.beUsingMouse())   
      // })

    },
    methods: {

      beUsingMouse() {
        document.body.classList.add('using-mouse')
        this.usingMouse = true
        this.usingTab = false
      },

      beUsingTab() {
        document.body.classList.remove('using-mouse')
        this.usingMouse = false
        this.usingTab = true
      },

      dispatchResize() {
        if(this.$delay) this.$delay.kill()
        this.$delay = TweenMax.delayedCall(.2, this.onResize)
        
      },
      onResize() {
        this.width = window.innerWidth
        this.height = window.innerHeight
        this.orientation = this.width > this.height ? 'landscape' : 'portrait'
      },
      below(type) { return this.width <= this.$sizes[type] },
      above(type) { return this.width >= this.$sizes[type] },
      reload() {
        window.location.reload(true);
      },
    },
    watch: {
      // 'orientation'(nw, od){
      //   if(od == 'landscape' && this.compte > 0)
      //     this.reload()
      //   this.compte += 1
      // }
    },

    render: h => h(App)
  })
}

init()
